import React, {useState} from "react";
import {Button} from "antd";
import {useStore} from "@vigo/hooks";

export const RetryInvoiceAccountButton = ({courierId}) => {
    const stores = useStore();
    const [loading, setLoading] = useState(false);

    const getCookie = name => {
        const match = document.cookie.match(
            new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\/\+^])/g, "\\$1") + "=([^;]*)")
        );
        return match ? decodeURIComponent(match[1]) : null;
    };

    const setCookie = (name, value, maxAgeSeconds) => {
        document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}`;
    };

    const clearCookie = name => {
        document.cookie = `${name}=; path=/; max-age=0`;
    };

    const handleClick = async () => {
        const cookieName = `check-invoiceAccountStatus-${courierId}`;
        const existing = getCookie(cookieName);
        if (existing) {
            const expiry = parseInt(existing, 10);
            if (!isNaN(expiry)) {
                const remainingMs = expiry - Date.now();
                if (remainingMs > 0) {
                    const mins = Math.floor(remainingMs / 60000);
                    const secs = Math.ceil((remainingMs % 60000) / 1000);
                    stores.appStore.openErrorModal({
                        title: "İşlem Sınırı",
                        content: `Lütfen ${mins} dk ${secs} sn sonra tekrar deneyin.`
                    });
                    return;
                }
            }
            clearCookie(cookieName);
        }

        setCookie(cookieName, String(Date.now() + 5 * 60 * 1000), 5 * 60);
        setLoading(true);

        try {
            const result = await stores.courierStore.checkInvoiceStatus(courierId);

            if (!result || result.data.success === false) {
                stores.appStore.openErrorModal({
                    content: result?.data?.message || "İşlem başarısız"
                });
                return;
            }

            stores.appStore.openSuccessModal({
                title: "Bilgilendirme",
                content: result.data.message,
                okText: "Tamam"
            });
            return;
        } catch (error) {
            stores.appStore.openErrorModal({content: error.message || "İstek başarısız"});
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                size="small"
                type="primary"
                onClick={handleClick}
                loading={loading}
                style={{marginLeft: 5}}
            >
                Tekrar Dene
            </Button>
        </>
    );
};
